import {h, Fragment} from "preact"
//import { defaultConfig } from "../config"
import { useEffect } from "preact/hooks"
//import { HistoryElement, useAppStateSelector } from "@nosto/preact"

export default function History() {
    //const historyItems = useAppStateSelector(state => state.historyItems)

     useEffect(() => {
        nostojs(api => api.createRecommendationRequest()
            .setElements(['ns-autocomplete-rec'])
            .load()
        )
    }, [])

    return (
        <div class="ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-mx-auto">
            <div class="ns-w-100 ns-mt-sm-auto ns-autocomplete-inner">
                <div class="ns-autocomplete-products">
                    <div class="nosto_element ns-autocomplete-products-inner" id="ns-autocomplete-rec"></div>
                </div>
                <div class={`ns-autocomplete-keywords ns-d-flex ns-flex-column`}>
                    <div class="ns-autocomplete-header">Popular Searches</div>
                    <div class="ns-d-flex ns-flex-column">
                        {nostoSearch?.topSearches.map((search) => {
                            return (
                                <div class="ns-autocomplete-element ns-clickable ns-keyword">
                                    <a href={search.url}>
                                        <span>{search.text}</span>
                                    </a>
                                </div>
                            )
                        })}
                    </div>
                    <div class="ns-autocomplete-header" style="padding-top: 10px;">Collections</div>
                    <div class="ns-d-flex ns-flex-column">
                        {nostoSearch?.topCollections.map((collection) => {
                            return (
                                <div class="ns-autocomplete-element ns-clickable ns-keyword">
                                    <a href={collection.url}>
                                        <span>{collection.text}</span>
                                    </a>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}
